import { useEffect, useRef, useState } from "react";
import { confirmMonriReturn, isSignedMonriReturn } from "@/lib/monri-return-client";

/**
 * On a Monri success return, sends the signed URL to the server once so the
 * payment is confirmed even when the callback is lost. The href is captured on
 * first render, before the router can touch the query string. `onSettled`
 * runs after the server answered (e.g. to refetch the payment status).
 */
export function useConfirmMonriReturn(isSuccessReturn: boolean, onSettled?: () => void): void {
  const [href] = useState(() => (typeof window === "undefined" ? "" : window.location.href));
  const sent = useRef(false);
  const settled = useRef(onSettled);
  settled.current = onSettled;

  useEffect(() => {
    if (sent.current || !isSuccessReturn || !isSignedMonriReturn(href)) return;
    sent.current = true;
    void confirmMonriReturn(href).then(() => settled.current?.());
  }, [isSuccessReturn, href]);
}
